import template from './chatinput.pug'

export default Vue.extend({
  template: template(),
  data() {
    return {
      message: '',
      files: [],
      useDataBase: true,
      uploadedFiles: []
    }
  },
  methods: {
    t(key, options = {}) {
        return this.$t(`analytics.aiInfinity.${key}`, options)
    },
    handleFileInput(e) {
      const allowedExtensions = ['.csv', '.xlsx', '.xls', '.txt'];
      this.files = Array.from(e.target.files)

        const validFiles = this.files.filter(file => {
          const ext = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
          return allowedExtensions.includes(ext);
        });

      if (validFiles.length !== this.files.length) {
          this.$notifications.error(this.$t('analytics.aiInfinity.fileExtensionValidate'));
          return;
      }

      this.uploadedFiles.push(...this.files)
      e.target.value = null // limpia el input
    },
     removeFile(index) {
      this.uploadedFiles.splice(index, 1)
    },
    handleKeyDown(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
        this.sendMessage()
      }
    },
    autoResize() {
      this.$nextTick(() => {
        const ta = this.$refs.textarea
        ta.style.height = 'auto'
        ta.style.height = ta.scrollHeight + 'px'
      })
    },
    sendMessage() {
      if (!this.message.trim()) return
      this.$emit('send', this.message, this.files, this.useDataBase)
      this.message = ''
      this.files = []
      this.uploadedFiles=[]
      this.$refs.textarea.style.height = 'auto'
    },
    insertPrompt(prompt) {
        this.message = prompt; // Asume que usas `v-model="message"` en el textarea
        this.$nextTick(() => {
          this.$refs.textarea.focus();
        });
    }
  }
})
